import React from "react";
import Me from "../images/me.jpg";
import Button from "./Buttons";

function Header() {
    return (
        <div className="person">
            <img src={Me} className="Me" alt="Francisco Cardozo smiling to the camera." />
            <h1>Francisco Cardozo</h1>
            <h2>Prevention Scientist</h2>
            <p>
                <a href="https://focardozom.github.io" target="_blank" rel="noopener noreferrer">
                    https://focardozom.github.io
                </a>
            </p>
            <div className="buttons">
                <Button link="https://www.linkedin.com/in/francisco-cardozo-757050264/" text="LinkedIn" />
                <Button link="mailto:foc9@miami.edu" text="Email" />
            </div>
        </div>
    );
}

export default Header;